import LanguageSelector from './LanguageSelector.component';

export { LanguageSelector };

export default LanguageSelector;
